import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { initTitleLineRevealOnView } from '../parts/highlight-sweep';
gsap.registerPlugin(ScrollTrigger);
initTitleLineRevealOnView('.block-sticky-cards__hero-title', '.js--gradient-highlight-sticky-hero');
const SELECTOR_SECTION = '.block-sticky-cards';
const SELECTOR_BG = '.block-sticky-cards__bg-inner';
const INIT_ATTR = 'data-bg-lag-init';
const BREAKPOINT_XL = '(min-width: 1320px)';
const TRAVEL_FROM = -3;
const TRAVEL_TO = 3;
const SCRUB_LAG_SECONDS = 1;
const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const initBgLag = () => {
    document.querySelectorAll(SELECTOR_SECTION).forEach((section) => {
        if (section.hasAttribute(INIT_ATTR))
            return;
        section.setAttribute(INIT_ATTR, '');
        const bg = section.querySelector(SELECTOR_BG);
        if (!bg || reducedMotion())
            return;
        const mm = gsap.matchMedia();
        mm.add(BREAKPOINT_XL, () => {
            gsap.fromTo(bg, { yPercent: TRAVEL_FROM }, {
                yPercent: TRAVEL_TO,
                ease: 'none',
                scrollTrigger: {
                    trigger: section,
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: SCRUB_LAG_SECONDS,
                },
            });
        });
    });
};
document.addEventListener('DOMContentLoaded', initBgLag);
if (window.acf) {
    window.acf.addAction('render_block_preview', initBgLag);
}
window.addEventListener('load', () => ScrollTrigger.refresh());
export default initBgLag;
